import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { NumenLogo } from '@/presentation/components/numen-logo/numen-logo.js';
import { useApp } from '@/presentation/hooks/use-app.js';
import { APP_FONT_FAMILY } from '@/shared/constants/typography.js';

type BrandSignatureProps = {
    variant?: 'header' | 'centered';
    logoHeight?: number;
    showSubtitle?: boolean;
    logoUrl?: string;
};

const signatureTextSx = {
    fontFamily: APP_FONT_FAMILY,
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    lineHeight: 1.15,
    color: 'white'
} as const;

export function BrandSignature({ variant = 'header', logoHeight = 28, showSubtitle = false, logoUrl }: BrandSignatureProps) {
    const { translate } = useApp();
    const fontSize = variant === 'header' ? 10 : 11;

    const row = (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
            {logoUrl ? (
                <Box component="img" src={logoUrl} alt={translate('brand.name')} sx={{ height: logoHeight, width: 'auto', maxWidth: 160, objectFit: 'contain', display: 'block' }} />
            ) : (
                <NumenLogo height={logoHeight} />
            )}
            <Box sx={{ width: '1px', alignSelf: 'stretch', minHeight: logoHeight * 0.75, bgcolor: 'rgba(255,255,255,0.9)', flexShrink: 0 }} />
            <Typography sx={{ ...signatureTextSx, fontSize, pt: variant === 'header' ? '15px' : '24px' }} noWrap={variant === 'header'}>
                {translate('brand.name')}
            </Typography>
        </Box>
    );

    if (variant === 'header') {
        return row;
    }

    return (
        <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ display: 'inline-flex', justifyContent: 'center' }}>{row}</Box>
            {showSubtitle && (
                <Typography
                    sx={{
                        ...signatureTextSx,
                        fontSize: 9,
                        fontWeight: 500,
                        color: 'rgba(255,255,255,0.4)',
                        mt: 1.25,
                        letterSpacing: '0.06em'
                    }}
                >
                    {translate('brand.subtitle')}
                </Typography>
            )}
        </Box>
    );
}
